<template>
    <div>
        <WidgetSectionTitle :title="$t('product.trends')" class="mt-24 mb-8" title-class="font-light" />
        <WidgetProductList v-if="products" :products />
    </div>
</template>

<script lang="ts" setup>
const { data } = useTrendingProducts();

const products = computed(() => data.value);
</script>

<style></style>
